import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { SEO } from 'src/app/config';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent implements OnInit {

  constructor(
    private title: Title,
    private translate: TranslateService
  ) {
    this.translate.get('shared-pages.not-found.web-title').subscribe(() => {
      this.title.setTitle(this.translate.instant('shared-pages.not-found.web-title') + ` | ${SEO.TITLE}`);
    });
  }

  ngOnInit(): void {
  }
}
